var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5 33.0002L17.5 18.0002L2.5 3.00024","stroke":"#52668C","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"20","height":"36","viewBox":"0 0 20 36","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
